define('campanhas-controller',[],function() {

  var app = angular.module('campanhas.controller', [
      'campanhas.resource',
      'djds4rce.angular-socialshare',
      'ngMap',
      'vcRecaptcha'
  ]);

  app.controller('CampanhasController', ['$scope', 'Campanhas', 'Default', 'NgMap', "$metadata", "$location", "$FB", "vcRecaptchaService",
      function($scope, Campanhas, Default, NgMap, $metadata, $location, $FB, vcRecaptchaService) {

      $scope.urlCompartilhar = $location.absUrl();

      $scope.campanha = campanha;
          /*
           CONTATO IMOVEL
           */
          $scope.response = null;
          $scope.widgetId = null;
          $scope.recaptcha = {
              key: '6Le2PxkTAAAAABJWPWIkLPa9QJ-J40XaiZkANGTC'//chave do cliente de segurança
          };

          $scope.setResponse = function (response) {
              $scope.contato.recaptcharesponse = response;
          };
          $scope.setWidgetId = function (widgetId) {
              $scope.widgetId = widgetId;
          };
          $scope.cbExpiration = function() {
              vcRecaptchaService.reload($scope.widgetId);
              $scope.contato.recaptcharesponse = null;
          };

          $scope.contato = {
              nome: null,
              telefone:null,
              email:null,
              mensagem:null,
              recaptcharesponse:null
          };
          $scope.msgSucess = '';
          $scope.msgError = '';

          $scope.resetForm = function(){
              $scope.contato.nome = null;
              $scope.contato.telefone = null;
              $scope.contato.email = null;
              $scope.contato.mensagem = null;
              $scope.contato.recaptcharesponse = null;
          }

          $scope.resolveCaptcha = true;
          $scope.enviaContatoImovel = function(){
              if( $scope.contato.recaptcharesponse === ""){
                  $scope.resolveCaptcha = false;
                  return false;
              }else {
                  $scope.resolveCaptcha = true;
                  if ($scope.formContato.$valid) {
                      $("#ajaxbloq").fadeIn();
                      var obj = {
                          telefone: $scope.contato.telefone,
                          email: $scope.contato.email,
                          mensagem: $scope.contato.mensagem,
                          nome: $scope.contato.nome,
                          campanha: $scope.campanha,
                          recaptcharesponse:vcRecaptchaService.getResponse()
                      };
                      Campanhas.enviaContato(obj).then(function (result) {
                          if (result.data.ok) {
                              $scope.msgSucess = 'Mensagem Enviada com sucesso!';
                              $scope.msgError = '';
                              $scope.resetForm();
                              $scope.formContato.$setPristine();
                              $scope.cbExpiration();
                          } else {
                              $scope.msgSucess = '';
                              $scope.msgError = 'Mensagem não pode ser enviada tente mais tarde!';
                          }
                          $timeout(function () {
                              $("#msgInfo").fadeOut('slow', function () {
                                  $scope.msgSucess = '';
                                  $scope.msgError = '';
                              });
                          }, 5000);
                          $scope.resetForm();
                          $("#ajaxbloq").fadeOut();
                      });


                  } else {
                      angular.forEach($scope.formContato.$error.required, function (value, key) {
                          $scope.formContato.$error.required[key].$pristine = false;
                      });
                  }
              }
          }
  }]);
});

